module.exports = __webpack_public_path__ + "img/1 (124).706f9a84.png";